import { actionTypes } from 'redux-resource';
import * as api from 'api';

export const fetchOrders =
  (page = 1, params = {}) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'orders',
      requestKey: `fetchOrders${page}`,
      list: `fetchOrders${page}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchOrders(page, params)
      .then(({ data }) => {
        const { count, next, previous } = data;

        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: data.results,
          requestProperties: {
            perPage: data.results.length,
            count,
            next,
            previous,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
        });
      });
  };

export const findOrderById = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'orders',
    requestKey: `findOrderById`,
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .findOrderById(id)
    .then(({ data }) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const findPurchaseOrders =
  (purchaseId, page = 1) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'orders',
      requestKey: `findPurchaseOrders`,
      list: `purchaseOrders${purchaseId}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .findPurchaseOrders(purchaseId, page)
      .then(({ data }) => {
        const { count, next, previous } = data;

        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: data.results,
          requestProperties: {
            perPage: data.results.length,
            count,
            next,
            previous,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
          statusCode: err.response && err.response.status,
        });
      });
  };

export const confirmOrder = (orderId, payload) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'orders',
    requestKey: `confirmOrder`,
    resource: [orderId],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .confirmOrder(orderId, payload)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });

      return response;
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
        statusCode: err.response && err.response.status,
      });

      return err.response;
    });
};
